import { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import myContext from "../../../Context/myContext";
import Loader from "../../loader/Loader";

const CategoryPage = () => {
    const { categoryname } = useParams();
    const context = useContext(myContext);
    const { getAllProduct, loading } = context;
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState(""); // State for search term

    // Scroll to top when category changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [categoryname]);

    // Filter products by category and search term
    const filterProduct = getAllProduct
        .filter((obj) => obj.category.includes(categoryname))
        .filter((obj) =>
            obj.title.toLowerCase().includes(searchTerm.toLowerCase())
        );

    return (
        <div className="container mt-5">
            {/* Heading */}
            <div className="text-center mb-4">
                <h1 className="text-uppercase h2 font-weight-bold">{categoryname}</h1>
            </div>

            {/* Search Input */}
            <div className="row mb-4">
                <div className="col-md-6 offset-md-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search products..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} // Update search term on input change
                    />
                </div>
            </div>

            {loading ? (
                <div className="d-flex justify-content-center">
                    <Loader />
                </div>
            ) : (
                <section>
                    {/* Product Grid */}
                    <div className="row">
                        {filterProduct.length > 0 ? (
                            filterProduct.map((item, index) => {
                                const { id, title, price, productImageUrl } = item;
                                return (
                                    <div key={index} className="col-md-3 mb-4">
                                    <div className="card h-100 shadow-sm d-flex flex-column">
                                        <div
                                            style={{
                                                height: '300px', // Fixed height
                                                backgroundColor: '#cce5ff', // Blue background
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                padding: '10px', // Add padding for better visibility
                                            }}
                                        >
                                            <img
                                                onClick={() => navigate(`/productinfo/${id}`)}
                                                className="card-img-top img-fluid"
                                                style={{
                                                    cursor: "pointer",
                                                    height: "300px",
                                                    objectFit: 'contain' //
                                                }}
                                                src={productImageUrl}
                                                alt="Product"
                                            />
                                        </div>
                                        <div className="card-body d-flex flex-column">
                                            <h5 className="card-title">{title.substring(0, 25)}</h5>
                                            <p className="card-text text-muted">{price}</p>
                                            <button
                                                className="btn btn-primary mt-auto" // mt-auto pushes the button to the bottom
                                                onClick={() => navigate(`/productinfo/${id}`)}
                                                type="button"
                                            >
                                                Learn More
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                
                                );
                            })
                        ) : (
                            <div className="text-center">
                                <img
                                    className="mb-2"
                                    src="https://cdn-icons-png.flaticon.com/128/2748/2748614.png"
                                    alt="No Product"
                                />
                                <h1 className="h5">No {categoryname} products found</h1>
                            </div>
                        )}
                    </div>
                </section>
            )}
        </div>
    );
};

export default CategoryPage;
